import { createAPI } from '../../composable/useAPI';

export const useProductAPI = () => {
  const api = createAPI();

  const request = {
    product:{
      get: async (params) => {
        return await api.get('/api/v2/product', { params })
          .then((res) => { return res.data.data })
          .catch (err => { return false })
      },
      getCount: async (params) => {
        return await api.get('/api/v2/product/count', { params })
          .then((res) => { return res.data.data })
          .catch (err => { return false })
      },
      post: async (data) => {
        return await api.post('/api/v2/product', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },

      put: async (data) => {
          return await api.put('/api/v2/product', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => { console.error(err); return false })
      },

      delete: async(params) => {
        const queryString = params.map((seq) => `productSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/product?${queryString}`)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },
      findByCompanySeq: async (params) => {
        return await api.get('/api/v2/product/findByCompanySeq', { params })
          .then((res) => { return res.data.data })
          .catch (err => { console.error(err); return false })
      },
      download: async (params) => {
        try {
          const res = await api.get('/api/v2/product/download', {
            params,
            responseType: 'blob',
          });
          const contentType = res.headers['content-type'] ||
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          let filename = '제품_목록.xlsx';
          const dispo = res.headers['content-disposition'];
          if (dispo) {
            const m = /filename\*=UTF-8''([^;]+)|filename="([^"]+)"/i.exec(dispo);
            const raw = m?.[1] || m?.[2];
            if (raw) {
              try { filename = decodeURIComponent(raw); } catch { filename = raw; }
            }
          }
          const blob = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        } catch (err) {
          console.error('다운로드 실패:', err);
          throw err;
        }
      },
      import: async (formData) => {
        try {
          const response = await api.post('/api/v2/product/import', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials: true,
          });
          return response.data;
        } catch (error) {
          console.error('엑셀 업로드 실패:', error);
          return false;
        }
      }
    },
    productStockManagement:{
      get: async (params) => {
        return await api.get('/api/v2/product_stock_management', { params })
          .then((res) => { return res.data.data })
          .catch (err => { console.error(err); return false })
      },

      post: async (data) => {
        return await api.post('/api/v2/product_stock_management', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },

      put: async (data) => {
          return await api.put('/api/v2/product_stock_management', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => { console.error(err); return false })
      },

      delete: async(params) => {
        const queryString = params.map((seq) => `productSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/product_stock_management?${queryString}`)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      }
    },
    productIn:{
      get: async (params) => {
        return await api.get('/api/v2/product_in', { params })
          .then((res) => { return res.data.data})
          .catch (err => { console.error(err); return false })
      },

      post: async (data) => {
        return await api.post('/api/v2/product_in', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },

      put: async (data) => {
          return await api.put('/api/v2/product_in', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => { console.error(err); return false })
      },

      delete: async(params) => {
        const queryString = params.map((seq) => `productInSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/product_in?${queryString}`)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      }
    },
    productOut:{
      get: async (params) => {
        return await api.get('/api/v2/product_out', { params })
          .then((res) => { return res.data.data })
          .catch (err => { console.error(err); return false })
      },

      post: async (data) => {
        return await api.post('/api/v2/product_out', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },
      put: async (data) => {
          return await api.put('/api/v2/product_out', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },
      delete: async(params) => {
        const queryString = params.map((seq) => `productOutSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/product_out?${queryString}`)
          .then((res) => { return res.data.status === 200})
          .catch (err => { console.error(err); return false })
      }
    }
  };

  return {
    ...request
  };
}
